module.exports = __webpack_public_path__ + "img/secure.e9256983.webp";